import "./Loader.css";

interface LoaderProps {
  label?: string;
}

export function Loader({ label = "Lade…" }: LoaderProps) {
  return (
    <div className="bmd-loader">
      <span className="bmd-loader-spinner" aria-hidden="true" />
      <span className="bmd-loader-label">{label}</span>
    </div>
  );
}
